module.exports = __webpack_public_path__ + "static/media/kaltexlogo.31562414.jpeg";